module.exports = __webpack_public_path__ + "static/r-14a83ebba42f6c02e7da3279a8e6fd0c.jpg";